// extracted by mini-css-extract-plugin
export var cardIcon = "_6p-5";
export var cardIconUnframed = "_6p-9";
export var checkboxCard = "_6p-0";
export var checkboxCardSelected = "_6p-4";
export var disabled = "_6p-2";
export var interactive = "_6p-1";
export var outerBorder = "_6p-3";
export var spacerMedium = "_6p-8";
export var spacerSmall = "_6p-7";
export var spacerXsmall = "_6p-6";